import { useParams } from 'react-router-dom';
import { discountsService } from '../services/discountService';
import { useSuperMutation, useSuperQuery } from '@vadiun/react-hooks-legacy';
import { useState } from 'react';

export const useDiscounts = () => {
  const DiscountsService = discountsService();
  const params = useParams<{ id: string }>();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState<string | null>(null);
  const [filters, setFilters] = useState<any>({
    finished: 'false'
  });
  const [sort, setSort] = useState<{ sortDir: string; sortBy: string }>({
    sortDir: 'ASC',
    sortBy: 'from_date'
  });

  const getDiscounts = useSuperQuery(
    () =>
      DiscountsService.getDiscounts(
        page,
        rowsPerPage,
        search ? encodeURIComponent(search) : null,
        sort.sortBy,
        sort.sortDir,
        filters.finished
      ),
    {
      showSpinner: true
    },
    [page, rowsPerPage, search, sort, filters]
  );

  const handleChangePage = (newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (newRowsPerPage: number) => {
    setPage(1);
    setRowsPerPage(newRowsPerPage);
  };

  const handleSearchChange = (search: string | null) => {
    setPage(1);
    setSearch(search || null);
  };

  const handleSortChange = (direction: string | null, sortBy: string) => {
    setPage(1);
    setSort({
      sortDir: direction === 'desc' ? 'DESC' : 'ASC',
      sortBy
    });
  };
  const onFiltersChange = (filters: any) => {
    setPage(1);
    setFilters(filters);
  };

  const getAllDiscounts = useSuperMutation(
    () => DiscountsService.getDiscounts(null, null, null, null, null, null),  
    {
      showSuccessMessage: false
    }
  );

  const addDiscountMutation = useSuperMutation(DiscountsService.addDiscount, {
    onMutationFinish(state, arg) {
      getDiscounts.reload();
    },
    messages: {
      success: { message: 'El Descuento fue creado con exito' }
    }
  });

  const getDiscountById = useSuperQuery(
    () => {
      if (!params.id) return Promise.resolve(null);
      return DiscountsService.getDiscountById(params.id);
    },
    {
      showSpinner: true
    }
  );

  const editDiscountMutation = useSuperMutation(DiscountsService.editDiscount, {
    onMutationFinish(state, arg) {
      getDiscounts.reload();
    },
    messages: {
      success: {
        message: 'El Descuento fue editado con exito'
      }
    }
  });

  const deleteDiscountMutation = useSuperMutation(
    DiscountsService.deleteDiscount,
    {
      onMutationFinish(state, arg) {
        getDiscounts.reload();
      },
      messages: {
        success: {
          message: 'El Descuento fue eliminado con exito'
        }
      }
    }
  );

  return {
    discounts: getDiscounts.data?.docs || [],
    totalItems: getDiscounts.data?.totalDocs || 0,
    loading: getDiscounts.isLoading,
    error: getDiscounts.error,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    handleSearchChange,
    handleSortChange,
    filters,
    onFiltersChange,
    getAllDiscounts: getAllDiscounts.mutate,
    loadingAllDiscounts: getAllDiscounts.isLoading,
    allDiscountsData: getAllDiscounts.data || [],
    addDiscountMutation,
    loadingAddMutation: addDiscountMutation.isLoading,
    errorAddMutation: addDiscountMutation.error,
    reload: getDiscounts.reload,
    discount: getDiscountById.data,
    loadingDiscount: getDiscountById.isLoading,
    errorDiscount: getDiscountById.error,
    reloadDiscount: getDiscountById.reload,
    editDiscount: editDiscountMutation.mutate,
    loadingEditDiscount: editDiscountMutation.isLoading,
    errorEditDiscount: editDiscountMutation.error,
    deleteDiscount: deleteDiscountMutation.mutate,
    loadingDeleteDiscount: deleteDiscountMutation.isLoading,
    errorDeleteDiscount: deleteDiscountMutation.error
  };
};
